import React from 'react';
import { useIntl } from 'react-intl';

interface VideoContentProps {
  content: Array<string> | string;
}


const VideoContent: React.FC<VideoContentProps> = ({content}) => {
  const baseAssetPath = window.location.origin;
  const { formatMessage } = useIntl();
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video width='400' controls>
      <source src={`${baseAssetPath}${content}`} type='video/mp4' />
      {formatMessage({ id: 'messages.dev_app.video'})}
    </video>
  );
};

export default VideoContent;